import to from "await-to-js";

import database from "../../../../../utils/FirebaseController";
import logger from "../../../../../utils/LoggerFrontend";

const mapJobPageToAts = ({
  image = "",
  benefits = "",
  teaserText = "",
  companyLogo = "",
  tasks = "",
  requirements = "",
  mediaAssetId
}) => ({
  campaignData: { teaserImage: image, companyLogo, mediaAssetId },
  config: { benefitsText: benefits, formText: teaserText, tasks, requirements }
});

const mapAtsToJobPage = ({
  campaignData: { teaserImage: image, companyLogo, mediaAssetId } = {},
  config: { benefitsText: benefits, tasks, requirements, formText: teaserText }
}) => ({
  image,
  benefits,
  teaserText,
  companyLogo,
  tasks,
  requirements,
  mediaAssetId
});

export async function updateJobPage({ campaignId, jobPageData }) {
  const newAtsData = mapJobPageToAts(jobPageData);
  const [error, _result] = await to(database.updateAtsWithCampaignId(campaignId, newAtsData));

  if (error) {
    logger.log("error:JobPageService:updateJobPage", "unable to update job page", {
      campaignId,
      newAtsData,
      error
    });
    throw error;
  }
  logger.log("JobPageService:updateJobPage", "successfully updated ATS", {
    campaignId,
    newAtsData,
    _result
  });

  return;
}

export async function getJobPage(campaignId) {
  if (!campaignId) {
    logger.log("error:JobPageService:getJobPage", "campaignId is required", {
      campaignId
    });
    throw "campaignId is required";
  }

  const [error, atsData] = await to(database.getSingleEntry("ats", campaignId));
  if (error) {
    logger.log("error:JobPageService:getJobPage", "unable to fetch ats record", {
      campaignId,
      error
    });
    throw error;
  }

  const jobPageData = mapAtsToJobPage(atsData?.data());
  logger.log("JobPageService:getJobPage", "called database to fetch ats", {
    campaignId,
    jobPageData,
    atsData: atsData?.data()
  });

  return jobPageData;
}
